
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4.406l.406.188 10 4.5.594.25v12.688l-.5.281L16 28.157l-.5-.281L5 22.032V9.344l.594-.25 10-4.5zm0 2.188l-7.688 3.438L16 13.876l7.688-3.844zm-9 5.031v9.219l8 4.438v-9.656zm18 0l-8 4v9.656l8-4.438v-9.219z"}})])
          )
        }
      }
    